import { useContext } from "react";
import { useDispatch } from "react-redux";
import { initialize, reset } from "redux-form";
import { CreateTestTakersContext } from "../CreateTestTakerContext";

const useCleanData = () => {
    const dispatch = useDispatch()
    const { setErrorList } = useContext(CreateTestTakersContext)

    return (() => {
        dispatch(reset("test_takers"))
        dispatch(initialize('test_takers', {}));
        setErrorList([])
    })
}

export default useCleanData